import "./utils/themeBridge";

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import PushSubscriptionSync from './components/PushSubscriptionSync';
import { applyPreferredLocale } from './services/locale.service';
import router from './routes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import store from './store';

import "./assets/css/global.css"; 
import "./assets/css/mode.styles.css"; 
import "./assets/css/theme.styles.css"; 
import "./shared-components/dropdown/dropdown.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "swiper/css";

const root = ReactDOM.createRoot(document.getElementById('root'));

applyPreferredLocale();
serviceWorkerRegistration.register();

root.render(
  <Provider store={store}>
    <PushSubscriptionSync />
    <RouterProvider router={router}/>
  </Provider>
);
